import { appVersion } from "../statics/config";

const APP_ID_PATTERN = /^[a-z0-9._-]+$/;

const readValue = (env, key) => {
  const value = env ? env[key] : undefined;
  return typeof value === "string" ? value.trim() : "";
};

// Reads Atlas Analytics settings from a process.env-shaped object.
// Returns null when a required setting is missing or invalid.
// The collector is independent of the application's legacy/MW API base URL.
export function readAtlasConfig(env) {
  const endpoint =
    readValue(env, "REACT_APP_ATLAS_ENDPOINT") ||
    `https://analytics.saatteknoloji.com.tr/collect`;
  const appKey = readValue(env, "REACT_APP_ATLAS_APP_KEY");
  const appId = readValue(env, "REACT_APP_ATLAS_APP_ID").toLowerCase();
  const contentNamespace = readValue(env, "REACT_APP_ATLAS_CONTENT_NAMESPACE");
  const consentPolicy = readValue(env, "REACT_APP_ATLAS_CONSENT_POLICY");

  if (!endpoint || !appKey || !appId || !contentNamespace) {
    return null;
  }

  if (!APP_ID_PATTERN.test(appId)) {
    return null;
  }

  const config = { endpoint, appKey, contentNamespace, appId, appVersion };

  if (consentPolicy) {
    config.consentPolicy = consentPolicy;
  }

  return config;
}
